// const api = "http://localhost:1340/api";
// const host = "http://localhost:1340";

const api = "https://dealer-portal-api.wsio-api.com/api";
const host = "https://dealer-portal-api.wsio-api.com";

const locales = [];
const loqateKey = "AY75-WB66-NW49-BF43";

export { api, host, locales, loqateKey };